import * as Sentry from '@sentry/react'

import { getRuntimeEnv } from '@/lib/runtimeEnv'

let initialized = false

const parseRate = (value?: string, fallback = 0) => {
  if (!value) return fallback
  const parsed = Number(value)
  if (!Number.isFinite(parsed) || parsed < 0 || parsed > 1) return fallback
  return parsed
}

export function initSentry() {
  if (initialized) return

  const env = getRuntimeEnv()
  const dsn = env.VITE_SENTRY_DSN?.trim()
  if (!dsn) return

  initialized = true

  Sentry.init({
    dsn,
    environment: env.VITE_SENTRY_ENVIRONMENT?.trim() || import.meta.env.MODE,
    release:
      typeof __APP_GIT_SHA__ === 'string' && __APP_GIT_SHA__.length > 0
        ? __APP_GIT_SHA__
        : undefined,
    // Include stack traces consistently and capture uncaught errors/unhandled rejections
    // via default browser integrations.
    attachStacktrace: true,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: parseRate(env.VITE_SENTRY_TRACES_SAMPLE_RATE, 0.1),
  })
}

export async function withSpan<T>(
  options: { op: string; name: string; attributes?: Record<string, string | number | boolean> },
  fn: () => T | Promise<T>,
): Promise<T> {
  return Sentry.startSpan(
    {
      op: options.op,
      name: options.name,
      attributes: options.attributes,
    },
    async () => fn(),
  )
}

export { Sentry }
